import { Episode, Period, Prediction } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PriceMovementChart } from './components/price-movement-chart/PriceMovementChart';
import { PriceMovementTable } from './components/price-movement-table/PriceMovementTable';
import * as S from './PriceMovement.styles';

export interface PriceMovementProps {
  bestHorizon?: Period;
  episodes: Episode[];
  horizonToIndexOffset?: number;
  prediction: Prediction[];
  isFixedIncome?: boolean;
  useDynamicDaysLabel?: boolean;
}

export const PriceMovement = ({
  bestHorizon,
  episodes,
  horizonToIndexOffset,
  prediction,
  isFixedIncome,
  useDynamicDaysLabel,
}: PriceMovementProps) => {
  const { t } = useTranslation('widget');

  if (!prediction.length || !episodes.length) {
    return (
      <div data-testid="price-movement-empty">
        <img
          src="/terminal/static/images/illustrations/empty.svg"
          alt={t('widget:priceMovement.emptyAlt')}
        />
      </div>
    );
  }

  return (
    <S.PriceMovementRoot data-testid="price-movement">
      <PriceMovementChart
        prediction={prediction}
        horizonToIndexOffset={horizonToIndexOffset}
        bestHorizon={bestHorizon}
        isFixedIncome={isFixedIncome}
        useDynamicDaysLabel={useDynamicDaysLabel}
      />
      <PriceMovementTable episodes={episodes} isFixedIncome={isFixedIncome} />
    </S.PriceMovementRoot>
  );
};
